import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { de } from './de';
import { pt } from './pt';
import { hi } from './hi';
import { sw } from './sw';
import { zu } from './zu';
import { af } from './af';

export type LanguageCode = 'en' | 'es' | 'fr' | 'de' | 'pt' | 'hi' | 'sw' | 'zu' | 'af';

export interface LanguageOption {
  code: LanguageCode;
  label: string;
  nativeLabel: string;
  flag: string;
  region: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'en', label: 'English', nativeLabel: 'English', flag: '🇬🇧', region: 'Global / US / UK' },
  { code: 'es', label: 'Spanish', nativeLabel: 'Español', flag: '🇪🇸', region: 'Spain / LatAm' },
  { code: 'fr', label: 'French', nativeLabel: 'Français', flag: '🇫🇷', region: 'France / Francophone Africa' },
  { code: 'de', label: 'German', nativeLabel: 'Deutsch', flag: '🇩🇪', region: 'Germany / DACH' },
  { code: 'pt', label: 'Portuguese', nativeLabel: 'Português', flag: '🇵🇹', region: 'Portugal / Brazil / Angola' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी', flag: '🇮🇳', region: 'India / South Asia' },
  { code: 'sw', label: 'Swahili', nativeLabel: 'Kiswahili', flag: '🇰🇪', region: 'East & Central Africa' },
  { code: 'zu', label: 'isiZulu', nativeLabel: 'isiZulu', flag: '🇿🇦', region: 'South Africa' },
  { code: 'af', label: 'Afrikaans', nativeLabel: 'Afrikaans', flag: '🇿🇦', region: 'Southern Africa' },
];

export const TRANSLATIONS: Record<LanguageCode, Record<string, string>> = {
  en,
  es,
  fr,
  de,
  pt,
  hi,
  sw,
  zu,
  af,
};
